// extracted by mini-css-extract-plugin
export default {"container":"AddAddress_container__oB5zz","boxContainer":"AddAddress_boxContainer__FqYr4","inputRow":"AddAddress_inputRow__eSU-J","btnInput":"AddAddress_btnInput__EKGPq"};